import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class ChangeNumberService {

  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }
 
    /**
   * Description: Método que llama el servicio web que envia la solicitud de cambio de número
   * Autor: Diego Diaz
   * @param data parámetros de entrada
   * @return N/A
   */
  sendChangeNumberRequest(data){
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_CHANGE_NUMBER_REQUEST, data);
  }

  
 /**
   * Description: Método que llama el servicio web de obtener el imei marca y modelo de una linea
   * Autor: Diego Diaz
   * @param phone cédula del usuario
   * @return Mensaje de confirmación de la validación
   */
  getInfoLines(phone) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_GET_IMEI_LINES, { "identificationValue": phone });
  }

}
